import * as React from 'react';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { UserFilterSettingsModel } from "../../models/user/userFilterSettingsModel";
import AlphabeticalFilter from '../../common/components/alphabeticalFilter/alphabeticalFilter';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';

interface UserFilterProps {
  onSearchClick: any,
  totalRecordsCount: number
}

interface UserFilterState {
  userSettings: UserFilterSettingsModel,
  filterText: string
}

export class UserFilter extends React.Component<UserFilterProps, UserFilterState>  {
  constructor(props) {
    super(props);
    this.state = {
      userSettings: new UserFilterSettingsModel(),
      filterText: ''
    };
  }

  handleAlphaIndexChange = (letter: string) => {
    const currentSettings: UserFilterSettingsModel = { ...this.state.userSettings };
    currentSettings.name = '';
    currentSettings.email = '';
    currentSettings.alphaIndex = letter;
    const fiterText = this.generateFilterText(currentSettings);
    this.setState({
      userSettings: { ...currentSettings },
      filterText: fiterText
    });
    this.handleSearchButtonClick(currentSettings);
  }

  handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name;

    const currentSettings: UserFilterSettingsModel = { ...this.state.userSettings };
    currentSettings[name] = value;
    const fiterText = this.generateFilterText(currentSettings);
    this.setState({
      userSettings: { ...currentSettings },
      filterText: fiterText
    });
  }

  generateFilterText = (settings) => {
    let result = '';

    if (settings.alphaIndex) {
      result += "Start with <strong>'" + settings.alphaIndex + "'</strong>, "
    }
    if (settings.name) {
      result += "User name <strong>'" + settings.name + "'</strong>, "
    }
    if (settings.email) {
      result += "Email <strong>'" + settings.email + "'</strong>, "
    }
    if (settings.isActive !== null && settings.isActive !== undefined) {
      result += "Active: <strong>'" + (settings.isActive ? 'Yes' : 'No') + "'</strong>, "
    }
    if (settings.isDeleted !== null && settings.isDeleted !== undefined) {
      result += "Deleted: <strong>'" + (settings.isDeleted ? 'Yes' : 'No') + "'</strong>, "
    }

    return result.substr(0, result.length - 2);
  }

  handleSearchButtonClick = (settings) => {
    this.props.onSearchClick(settings);
  }

  handleClearButtonClick = () => {
    this.setState({
      userSettings: new UserFilterSettingsModel(),
      filterText: ''
    });
    this.handleSearchButtonClick(new UserFilterSettingsModel());
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick(this.state.userSettings)
    }
  }

  render() {
    return (
      <Toolbar style={{ marginBottom: '10px' }}>
        <AlphabeticalFilter
          handleAlphaIndexChange={this.handleAlphaIndexChange}
          filters={['en', 'bg']}
        />
        <div>
          <InputText
            onKeyPress={(e) => this.handleKeyPress(e)}
            style={{ marginRight: "10px", marginBottom: "5px" }}
            name="name"
            placeholder="Name"
            onChange={this.handleChange}
            value={this.state.userSettings && this.state.userSettings.name ? this.state.userSettings.name : ''}
          />
          <InputText
            onKeyPress={(e) => this.handleKeyPress(e)}
            name="email"
            placeholder="Email"
            style={{ marginRight: "10px", marginBottom: "5px" }}
            onChange={this.handleChange}
            value={this.state.userSettings && this.state.userSettings.email ? this.state.userSettings.email : ''}
          />
          <TriStateCheckbox
            inputId="isActive"
            name="isActive"
            value={this.state.userSettings.isActive}
            onChange={this.handleChange}
          />
          <label style={{ marginRight: "10px" }} htmlFor="isActive" className="p-checkbox-label">Active</label>
        </div>
        <div>
          <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
            Result: <strong>{this.props.totalRecordsCount}</strong>
            {this.state.filterText ? ', ' : ''}
            <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
          </div>
          <div style={{ float: "right" }}>
            <div>
              <Button
                className="p-button-raised"
                icon="pi pi-filter"
                style={{ marginRight: "10px" }}
                label="Filter"
                onClick={() => this.handleSearchButtonClick(this.state.userSettings)}
              />
              <Button
                className="p-button-secondary p-button-raised"
                label="Clear"
                icon="pi pi-times"
                onClick={() => this.handleClearButtonClick()}
              />
            </div>
          </div>
        </div>
      </Toolbar>
    )
  }
}

export default UserFilter;
